import React from 'react';
import { Button } from 'react-bootstrap';
import { faChartSimple } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

function SurveyReportButton({ survey }) {
  return (
    <Button
      title="Report Summary"
      size="md"
      variant="light"
      href={`/survey/${survey.surveyId}/report`}
      target="_blank"
    >
      <FontAwesomeIcon icon={faChartSimple} />
    </Button>
  );
}

SurveyReportButton.propTypes = {
  survey: PropTypes.shape({
    surveyId: PropTypes.string,
  }),
};

export default SurveyReportButton;
